// Importing React and external libs
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

// Importing antd
import 'antd/es/alert/style/css';

// Importing antd icons
import {
  CheckCircleFilled,
  CloseCircleFilled,
  InfoCircleFilled
} from '@ant-design/icons';

// Importing helix components
import Error from 'helix/ui/error';

// Importing component style
import './style.scss';

const MSG_ICON = {
  'error': <CloseCircleFilled />,
  'info': <InfoCircleFilled />,
  'success': <CheckCircleFilled />,
};

const Item = (props) => {
  const { message, type } = props;
  return (
    <div className={`ant-alert ant-alert-${type}`}>
      <div className='alert-icon'>{MSG_ICON[type]}</div>
      <div className='alert-text'>{message}</div>
    </div>
  );
};

const AlertBox = (props) => {
  const { dataField, empty, parser, reader } = props;
  const [error, setError] = useState(undefined);
  const [objects, setObjects] = useState(undefined);

  useEffect(() => {
    async function _loadData() {
      const res = await reader();
      if (res.error) return setError(res.msg);
      setObjects(res[dataField]);
    }
    _loadData();
  }, []);

  return (
    <div className="alert-wrapper">
      {error
        ? <Error message={error} imgSrc='' />
        : ((objects && objects.length > 0 && objects.map((raw, index) => (
          <Item key={index} message={parser(raw)} type={raw.type} />
        )))) || <p>{empty}</p>
      }
    </div>
  );
};

AlertBox.propTypes = {
  dataField: PropTypes.string,
  empty: PropTypes.string,
  parser: PropTypes.func,
  reader: PropTypes.func,
};

AlertBox.defaultProps = {
  dataField: 'results',
  empty: 'No alerts to be displayed.',
  parser: (raw) => raw.msg,
  reader: () => ({}),
};

export default AlertBox;
